<template>
    <div class="about">
        <Inbanner :name="bannerName"/>
        <div class="container">
            <el-breadcrumb separator="/" style="margin:20px 0;">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻</el-breadcrumb-item>
                <el-breadcrumb-item>{{radioName}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card">
               <div class="radio-group-class">
                    <el-radio-group v-model="radioName" @input="changeRadio()">
                        <el-radio-button label="公司动态"></el-radio-button>
                        <el-radio-button label="行业动态"></el-radio-button>
                    </el-radio-group>
                </div>
                <div v-for="(item, index) in tableData" :key="index" style="margin-top: 20px">
                    <div class="news-list wow fadeInUp">
                          <el-card shadow="hover">
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    
                                    <router-link :to="item.link" tag="a" target="_blank">
                                        <img :src="item.cover" style="max-width: 100%;max-height: 160px">
                                    </router-link>
                                </el-col>
                                <el-col :span="18">
                                    <h5><router-link :to="item.link" tag="a" target="_blank">{{item.title}}</router-link></h5>
                                    <div class="news-list-brief">
                                        <p>
                                            <router-link :to="item.link" tag="a" target="_blank">{{item.description}}</router-link>
                                        </p>
                                    </div>
                                    <div class="clearfix">
                                        <div class="float-start">
                                            <span class="news-editer"><i class="el-icon-user-solid"></i> 仁迅科技</span>
                                            <span class="news-time"><i class="el-icon-date"></i> {{item.publishTime}}</span>
                                        </div>
                                        <div class="float-end">
                                            <img class="news-light" src="@/assets/img/news/line.svg">
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-card>
                    </div>
                </div>
                <div style="float: right; margin-bottom: 15px;">
                    <el-pagination @current-change="handleCurrentChange" :current-page="queryParams.pageNum"
                        :page-size="10" layout="prev, pager, next"
                        :total="total" background>
                    </el-pagination>
                </div>
            </el-card>
           
        </div>
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
import { getNewList } from '@/api/news';
export default{
    data() {
        return {
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                category: this.getUrlParam("category")
            },
            tableData: [],
            total: 0,
            radioName: '公司动态',
            bannerName: ''
        };
    },
    components:{
        Inbanner
    },
    watch:{
        '$route'() {//监听到路由（参数）改变
            this.queryParams.category = this.getUrlParam("category")
            if(this.queryParams.category == 1) {
                this.radioName = "公司动态"
                this.bannerName = "公司新闻"
            }else if(this.queryParams.category == 2) {
                this.radioName = "行业动态"
                this.bannerName = "行业新闻"
            }
            this.getNewsData()
        }
    },
    created() {
        if(this.queryParams.category == 1) {
            this.radioName = "公司动态"
            this.bannerName = "公司新闻"
        }else if(this.queryParams.category == 2) {
            this.radioName = "行业动态"
            this.bannerName = "行业新闻"
        }

        this.getNewsData()
    },
    methods: {
        getNewsData(){
            this.newsCategoryName = this.getUrlParam("category") == 1 ? "公司新闻" : "行业新闻"
            this.tableData = []
            getNewList(this.queryParams).then(res => {
                this.total = res.recordsTotal
                res.data.forEach(d => {
                    d.link = "news1?id=" + d.id
                    // 格式化日期
                    if(d.publishTime){
                        let newDate = new Date(d.publishTime);
                        var year = newDate.getFullYear(); //得到年份
                        var month = newDate.getMonth(); //得到月份
                        var date = newDate.getDate(); //得到日期
                        month = month + 1;
                        if (month < 10) month = "0" + month;
                        if (date < 10) date = "0" + date;
                        d.publishTime = year + "-" + month + "-" + date; //（格式化"yyyy-MM-dd"
                    }
                    this.tableData.push(d)
                });
            })
        },
        // 分页变化回调函数
        handleCurrentChange(page){
            this.queryParams.pageNum = page;
            this.carouselTableData = []
            this.tableData = []
            this.getNewsData()
        },
        // 按钮组切换
        changeRadio(){
            if(this.radioName == "公司动态") this.queryParams.category = 1
            if(this.radioName == "行业动态") this.queryParams.category = 2
            window.location.href = `#/newsList?category=${this.queryParams.category}`
        },
        getUrlParam(name) {
            let url = window.location.hash.split('#')[1].split('?')[1].split('&')
            for(var i=0;i<url.length;i++){         //遍历数组，拿到json对象
                if(url[i].split('=')[0] == name){
                    return url[i].split('=')[1]
                }
            }
            return null
        }
    }
}
</script>
<style>
    .news-list {
        margin-bottom: 30px;
    }
    h5 {
        font-size: 18px;
        line-height: 1.3380952381;
        font-weight: 500;
        margin: 0;
    }
    .news-list-brief {
        height: 120px;
    }
    .float-start {
        float: left!important;
    }
    .news-editer {
        margin-right: 10px;
    }

    .float-end {
        float: right!important;
    }
    .radio-group-class{
        margin-top: 15px;
        text-align: center;
    }
    .el-radio-button__inner{
        width: 300px!important;
    }

</style>
